import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectInfo } from 'src/app/Models/audit/ProjectInfo';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http:HttpClient) { }
  private apiUrl=environment.apiUrl;
  public GsdUrl = environment.GSDapiUrl

  private url = this.apiUrl + 'api/ProjectConnectDetails';
  private url2 = this.apiUrl + 'api/ProjectDetailsView/GetProjectConnectDetails';

  month: number;
  year: number;

  getProjectDropdown(managerId: number, month: number, year: number): Observable<any> {
    return this.http.get<any>(this.url + "/getProjectDropdown" + '?managerId=' + managerId + '&month=' + month + '&year=' + year);
  }

  getBlocker(): Observable<any> {
    return this.http.get<any>(this.url + "/getBlocker");
  }
  getImprovement(): Observable<any> {
    return this.http.get<any>(this.url + "/getImprovement");
  }
  getStrategicIntiative(): Observable<any> {
    return this.http.get<any>(this.url + "/getStrategicIntiative");
  }
  getClientValue(): Observable<any> {
    return this.http.get<any>(this.url + "/getClientValue");
  }
  getPracticeValue(): Observable<any> {
    return this.http.get<any>(this.url + "/getPracticeValue");
  }

  saveProjectData(data: any): Observable<any> {
    return this.http.post<any>(this.url + "/create", data);

  }
  editProjectData(data: any): Observable<any> {
    return this.http.post<any>(this.url + "/edit", data);
  }

  getData(managerId: number, month: number, year: number): Observable<any> {
    return this.http.get<any>(this.url2 + '?projectId=' + managerId + '&month=' + month + '&year=' + year);
  }
  getprojectconnectdetails(projectId: number, month: number, year: number): Observable<any> {
    return this.http.get<any>(this.url2 + '?projectId=' + projectId + '&month=' + month + '&year=' + year);
  }

  getProjects(): Observable<ProjectInfo[]> {
    return this.http.get<ProjectInfo[]>(`${this.apiUrl}ProjectDetails/getProjectListDetails`);
  }

  getIfUserCanCreateAudit(): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}Audit/GetIfUserCanCreateAudit`);
  }

}